import * as React from 'react';
import Fancybox from './fancybox';


import './galery.scss';


  export default function Galery(){


    return(
        <>
          <section id="project-section">
            <div className='container galery-row'>
                <h1>Galeria de fotos</h1>
              <Fancybox>
                <div className="galery-photos">
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/barcarena-drs/1024x768/2.jpg">
                    <img alt="" src="https://gruposeculos.com.br/files/barcarena-drs/330x350/1.jpg" className='img-fluid'
                      data-aos="fade-zoom-in" 
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/barcarena-drs/1024x768/1.jpg">
                    <img alt="" src="https://gruposeculos.com.br/files/barcarena-drs/330x350/2.jpg" className='img-fluid'
                      data-aos="fade-zoom-in" 
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/barcarena-drs/1024x768/8.jpg">
                    <img alt="" src="https://gruposeculos.com.br/files/barcarena-drs/330x350/3.jpg" className='img-fluid'
                    data-aos="fade-zoom-in" 
                    data-aos-duration="1000"
                    data-aos-delay="300"
                    data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/barcarena-drs/1024x768/7.jpg">
                    <img alt="" src="https://gruposeculos.com.br/files/barcarena-drs/330x350/4.jpg" className='img-fluid' 
                      data-aos="fade-zoom-in" 
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/barcarena-drs/1024x768/6.jpg">
                    <img alt="" src="https://gruposeculos.com.br/files/barcarena-drs/330x350/5.jpg" className='img-fluid'
                      data-aos="fade-zoom-in" 
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/barcarena-drs/1024x768/5.jpg">
                    
                    <img alt="" src="https://gruposeculos.com.br/files/barcarena-drs/330x350/6.jpg" className='img-fluid'
                      data-aos="fade-zoom-in"
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/barcarena-drs/1024x768/4.jpg">
                    
                    <img alt="" src="https://gruposeculos.com.br/files/barcarena-drs/330x350/7.jpg" className='img-fluid'
                      data-aos="fade-zoom-in" 
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                  <a data-fancybox="gallery" href="https://gruposeculos.com.br/files/barcarena-drs/1024x768/3.jpg">
                    
                    <img alt="" src="https://gruposeculos.com.br/files/barcarena-drs/330x350/8.jpg" className='img-fluid'
                      data-aos="fade-zoom-in" 
                      data-aos-duration="1000"
                      data-aos-delay="300"
                      data-aos-offse="0"
                    />
                  </a>
                </div>
              </Fancybox>

            </div>
          </section>
        </>
    )
}

